export const errorMapping = {
  phone: 'Phone Number field. Please enter a valid phone number.',
  dateOfBirth: 'Date of Birth field. Please enter a valid date.',
  dateOfHire: 'Service Computation Date field. Please enter a valid date.',
  militaryActiveDutyStartDate:
    'Active Duty Start Date field. Please enter a valid date.',
  militaryActiveDutyEndDate:
    'Active Duty Discharge Date field. Please enter a valid date.',
  militaryReservesStartDate:
    'Reserves Start Date field. Please enter a valid date.',
  militaryReservesEndDate:
    'Reserves Discharge Date field. Please enter a valid date.',
  familyChildren: 'Number of Children field. Please enter a number.',
  familySpouseDateOfBirth: `Spouse's Date of Birth field. Please enter a valid date.`,
  familyDivorcedMarriageStartDate:
    'Marriage Date With Former Spouse field. Please enter a valid date.',
  familyDivorcedMarriageEndDate:
    'Divorce Date With Former Spouse field. Please enter a valid date.',
  currentLeaveBalance:
    'Current Earned Annual Leave Balance field. Please enter a number.',
  currentSickLeaveBalance:
    'Current Sick Leave (Hours) field. Please enter a number.',
}
